// @flow

import composeAssetsDataTable from './datatable'
export default composeAssetsDataTable
